<script setup lang="ts">
const props = defineProps<{
  variant: PacketVariant;
  cardClass?: string; // FIXME: This is a bad API
}>();

const totStudents = useTotStudents();

const min = computed(() => props.variant.fixedAmount ? totStudents.value : 1);

const quantity = ref(min.value);

const title = computed(() => props.variant.customName || props.variant.title || props.variant.name);

provide(keys.packetQuantity, {
  min,
  quantity,
});
</script>

<template>
  <div class="@container">
    <slot :title="title" />
    <div class="flex flex-col items-center gap-xs rounded-sm bg-white @sm:flex-row @sm:gap-m" :class="cardClass">
      <PacketTotalSum :variant="variant" />
      <AddToCartButton
        :variant="variant"
        :quantity="quantity"
        :aria-label="`Legg ${quantity} tilganger på ${title} i handlekurven.`"
      >
        Legg i handlekurv
      </AddToCartButton>
    </div>
  </div>
</template>
